import List from './List.vue'
import Excel from './Excel.vue'
import Review from './Review.vue'

export default [
  {
    path: 'review/list/:id',
    name: 'Reports List',
    component: List,
    meta: {
      profiles: ['admin', 'user', 'adminTi', 'audit']
    }
  },
  {
    path: 'reviews-excel',
    name: 'Reports Excel',
    component: Excel,
    meta: {
      profiles: ['admin', 'user', 'adminTi', 'audit']
    }
  },
  {
    path: 'reviews/:id',
    name: 'Review Report',
    component: Review,
    meta: {
      profiles: ['admin', 'user', 'adminTi', 'audit']
    }
  },
]
